import { React, useState, useMemo, useEffect } from 'react'
import { useSearchParams, Routes, Route, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client'
import ThousandSeperator from '../../../Utils/ThousandSeperator';
// import { useState } from 'react';
import PE_VC from '../../../images/noun-investment-2180740_4/png/noun-investment-2180740.png';
import TF_US from '../../../images/Shape_4/png/Shape.png';
import TF_INR from '../../../images/noun-investment-2180740_2/png/noun-investment-2180740.png';
import Company from '../../../images/noun-investment-2180740_5/png/noun-investment-2180740.png';
import { invIncTopCard } from '../../../Config/config'
import axios from 'axios'
import { useContext } from 'react';
import { UserContext } from '../../../Contexts/UserContext';
import useModule from '../../../hooks/useModule';
// import RefineSearch from '../HeaderComponent/RefineSearch';
// import Enterprice from "./Enterprice"

/**
 * The code defines a functional component called InvestorIncubationDetailCard that fetches data from
 * an API and sets it to the state variable detailCard.
 */
const InvestorIncubationDetailCard = (props) => {

  const [detailCard, setDetailCard] = useState({});
  const { investorId } = useParams();
  let investorProfileId = parseInt(investorId)
  const { getToken } = useContext(UserContext);
  const { primaryMasterId } = useModule();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    axios(`${invIncTopCard}`, {
      method: "POST",
      data: {
        "investor_id": investorProfileId,
        "type": primaryMasterId,
        "category": props?.page
      },
      headers: {
        "Content-Type": "application/json",
        'Authorization': getToken(),
      },
    })
      .then((response) => {
        setIsLoading(false);
        setDetailCard(response?.data?.data)
      })
      .catch((error) => { 
        setIsLoading(false);
        console.log("API not working", error);
      });
  }, [investorProfileId])

  const InvestorDetailCardData = useMemo(() => detailCard, [detailCard]);

  console.log(InvestorDetailCardData, "InvestorDetailCardData")


  return (
    <div className="">
      <div className='sm:full mt-[4.25rem] md:mt-[3rem] h-full  bg-[#F2F2F2]'>
        {/* <div> */}
        <div className="overflow-x-auto lg:grid grid-cols-5 gap-4  px-4 py-[0.7rem] flex xl:overflow-hidden scrollbar-remove">
          {/* ----InvestorCard1----- */}
          <section className="flex-shrink-0 ">
            <div className="bg-white px-3 py-1 rounded-md  border border-gray-200 overflow-hidden card-animate">
              <div className="grid grid-cols-6 ">
                <div className="col-span-5">

                  <div className="text-[13pt] leading-[17pt] lg:text-[13px] text-[#2B2A29] lg:leading-[17px] font-sans_book_body tracking-[-0.3px]">Portfolio Cos/deals</div>
                  {Object.keys(InvestorDetailCardData).length > 0 ?
                    // InvestorDetailCardData?.InvestorFund?.investorCompanycnt!=null && InvestorDetailCardData?.InvestorFund?.investorCompanycnt!=0&&
                    // InvestorDetailCardData?.InvestorFund?.investorDealcnt!=null && InvestorDetailCardData?.InvestorFund?.investorDealcnt!=0?
                    <div className="flex space-x-1  tracking-[-0.3px]">
                      {InvestorDetailCardData?.company_count != null && InvestorDetailCardData?.company_count != 0 && InvestorDetailCardData?.deal_count != null && InvestorDetailCardData?.deal_count != 0
                        ? < div className="  text-[#A5711A] ">
                          <span
                            className=' text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  '>
                            <ThousandSeperator value={InvestorDetailCardData?.company_count ? InvestorDetailCardData?.company_count : "--"} />
                          </span>
                          <span className=' font-bold text-[#A5711A]  text-[18pt] lg:text-[17px] leading-[23px] tracking-[-0.3px] '>/</span>
                          <span
                            className='text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  '>
                            <ThousandSeperator value={InvestorDetailCardData?.deal_count ? InvestorDetailCardData?.deal_count : "--"} />
                          </span>
                        </div>
                        : <span className='  text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A] '>--</span>}
                    </div>
                    // :<div className="font-semibold text-[#A5711A]">--</div>
                    :
                    <div className="w-full bg-[#FFFFFF]">
                      <div role="status" className="bg-white">
                        <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                      </div>
                    </div>
                  }
                </div>
                <div className="flex-shrink-0 pl-5 flex items-center justify-center">

                  <img className=" pointer-events-none h-[22px] max-w-[25px]" fill="currentColor"
                    src={PE_VC} />

                </div>
              </div>
            </div>
          </section>
          {/* ----InvestorCard2----- */}
          <section className="flex-shrink-0">
            <div className=" bg-white px-3 py-1 rounded-md  border border-gray-200 overflow-hidden card-animate card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4">
                  <div className="text-[13pt] leading-[17pt] lg:text-[13px] text-[#2B2A29] lg:leading-[17px] font-sans_book_body tracking-[-0.3px]">No. of funds </div>
                  {Object.keys(InvestorDetailCardData).length > 0 ?
                    <div className="flex space-x-1 tracking-[-0.3px]">
                      <div className="  text-[#A5711A] ">
                        <span
                          className='  text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A] '>
                          {/* <ThousandSeperator  value= */}
                          {InvestorDetailCardData?.fund_count == 0 || InvestorDetailCardData?.fund_count == null ? "--" : InvestorDetailCardData?.fund_count}
                          {/* /> */}
                        </span>

                      </div>
                    </div>
                    :
                    <div className="w-full bg-[#FFFFFF]">
                      <div role="status" className="bg-white">
                        <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                      </div>
                    </div>
                  }
                </div>
                {/* <div className=""> */}
                <div className="flex-shrink-0 flex pl-5 items-center justify-center ">

                  <img className=" pointer-events-none h-[24px] max-w-[25px] "
                    src={TF_US} />

                </div>
                {/* </div> */}
              </div>
            </div>
          </section>
          {/* ----InvestorCard3----- */}
          <section className="flex-shrink-0 ">
            <div className=" bg-white px-3  py-1 rounded-md  border border-gray-200 overflow-hidden">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className="text-[13pt] leading-[17pt] lg:text-[13px] text-[#2B2A29] lg:leading-[17px] font-sans_book_body tracking-[-0.3px]">No. of exits </div>
                  {Object.keys(InvestorDetailCardData).length > 0 ?
                    <div className="flex space-x-1 ">
                      <div className="  ">
                        <span
                          className='  text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A] '>
                          {/* <ThousandSeperator  value= */}
                          {InvestorDetailCardData?.exit_count == null ? "--" : InvestorDetailCardData?.exit_count == 0 ? "--" : InvestorDetailCardData?.exit_count}
                          {/* /> */}
                        </span>
                      </div>
                    </div>
                    :
                    <div className="w-full bg-[#FFFFFF]">
                      <div role="status" className="bg-white">
                        <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                      </div>
                    </div>
                  }
                </div>
                <div className="flex-shrink-0 flex pl-5 items-center justify-center">

                  <img className=" pointer-events-none h-[26px] max-w-[25px]"
                    src={TF_INR} />

                </div>
              </div>
            </div>
          </section>
          {/* ----InvestorCard4----- */}
          <section className="flex-shrink-0 ">
            <div className=" bg-white px-3 py-1 rounded-md  border border-gray-200 overflow-hidden card-animate card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className="text-[13pt] leading-[17pt] lg:text-[13px] text-[#2B2A29] lg:leading-[17px] font-sans_book_body tracking-[-0.3px]">Unicorns </div>
                  {Object.keys(InvestorDetailCardData).length > 0 ?
                    <div className="flex space-x-1 ">
                      <div className="  text-[#A5711A] ">
                        <span
                          className=' text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  '>
                          {/* <ThousandSeperator  value= */}
                          {InvestorDetailCardData?.unicorn_count == 0 || InvestorDetailCardData?.unicorn_count == null ? "--" : InvestorDetailCardData?.unicorn_count}
                          {/* // /> */}
                        </span>
                      </div>
                    </div>
                    :
                    <div className="w-full bg-[#FFFFFF]">
                      <div role="status" className="bg-white">
                        <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                      </div>
                    </div>
                  }
                </div>
                <div className="flex-shrink-0 flex pl-5 items-center justify-center">

                  <img className=" pointer-events-none h-[26px] max-w-[25px]"
                    src={Company} />

                </div>
              </div>
            </div>
          </section>
          {/* ----InvestorCard5----- */}
          <section className="flex-shrink-0 ">
            <div className=" bg-white px-3 py-1 rounded-md  border border-gray-200 overflow-hidden card-animate card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-1 ">
                  <div className="text-[13pt] leading-[17pt] lg:text-[13px] text-[#2B2A29] lg:leading-[17px] font-sans_book_body tracking-[-0.3px]">IPOs </div>
                  {Object.keys(InvestorDetailCardData).length > 0 ?
                    <div className="flex space-x-1  tracking-[-0.3px]">
                      <div className="  ">
                        <span
                          className=' text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  '>
                          {/* <ThousandSeperator  value= */}
                          {InvestorDetailCardData?.ipo_count == 0 || InvestorDetailCardData?.ipo_count == null ? "--" : InvestorDetailCardData?.ipo_count}
                          {/* />  */}
                        </span>

                      </div>
                    </div>
                    :
                    <div className="w-full bg-[#FFFFFF]">
                      <div role="status" className="bg-white">
                        <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </section>

        </div>
        {/* </div> */}
        <div className='border-b-2 border-[#e5e5e5]'></div>

        {/* <Enterprice/> */}

      </div >
    </div >
  )
}

export default InvestorIncubationDetailCard;